<app-template-radio [disabled]="disabled" [value]="value" [control]="control" [options]="options" [direction]="direction" [label]="label" />
